<!-- @file 主账号账单统计页面 -->
<template>
  <div>
    <plv-condition-filter v-model="conditionFilter" class="p-allocatable-resources__filter" @search="handleSearch">
      <plv-row
        :gutter="[
          {
            sm: 48,
            md: 48,
            lg: 16,
            xl: 16,
            xxl: 16,
          },
          0
        ]"
      >
        <plv-col :span="colSpan">
          <plv-condition-filter-item
            width="100%"
            prop="email"
            label="分账号邮箱"
            type="input"
            placeholder="请输入"
          />
        </plv-col>
        <plv-col :span="colSpan">
          <plv-condition-filter-item
            width="100%"
            prop="alterationType"
            label="变动类型"
            type="select"
            :select-options="typeOptions"
            clearable
          />
        </plv-col>
        <plv-col :span="colSpan">
          <plv-condition-filter-item
            width="100%"
            prop="resourceCodes"
            label="变动资源"
            type="select"
            :select-options="materialOptions"
          />
        </plv-col>
        <plv-col :span="colSpan">
          <plv-condition-filter-item
            label="操作时间"
          >
            <el-date-picker
              v-model="conditionFilter.dateRange"
              value-format="timestamp"
              size="small"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :default-time="['00:00:00', '23:59:59']"
            />
          </plv-condition-filter-item>
        </plv-col>

        <plv-col :span="colSpan">
          <div class="p-allocatable-resources__btn-group">
            <plv-condition-filter-item type="search" />
            <plv-button size="medium" type="operate" @click="handleReset">重置</plv-button>
          </div>
        </plv-col>
      </plv-row>
    </plv-condition-filter>

    <plv-button class="p-allocatable-resources__export-btn" @click="handleExport">导出数据</plv-button>

    <div class="p-allocatable-resources">
      <plv-table
        v-loading="loading"
        :data-source.sync="dataSource"
        @pageDataChange="handlePageChange"
      >
        <plv-table-column
          v-for="item of tableItems"
          :key="item.prop"
          :title="item.title"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'availableResource'">
              {{ scope.rowData.availableResource | decimalFormat }}
            </span>
            <span v-else-if="item.prop === 'value'">
              {{ scope.rowData.value + scope.rowData.unit }}
            </span>
            <span v-else-if="item.prop === 'createTime'">
              {{ scope.rowData.createTime | formatDate }}
            </span>
            <span v-else>
              {{ scope.rowData[item.prop] || '-' }}
            </span>
          </template>
        </plv-table-column>
      </plv-table>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { dataExportMixin } from '@/mixins/data-export';

export default {
  mixins: [dataExportMixin],
  data() {
    return {
      loading: false,
      recordDetailVisible: false,
      data: null,
      tableItems: [
        { title: '分账号邮箱', prop: 'email' },
        { title: '变动类型', prop: 'alterationType' },
        { title: '变动资源', prop: 'resourceCodeDesc' },
        { title: '变动数量', prop: 'value' },
        { title: '操作时间', prop: 'createTime' }
      ],
      typeOptions: [
        {
          label: '分配',
          value: '0',
        },
        {
          label: '回收',
          value: '1',
        },
        {
          label: '到期清零',
          value: '2',
        }
      ],
      materialOptions: [
        {
          label: '金额',
          value: 'balance',
        },
        {
          label: '资源点',
          value: 'resourcePoint',
        },
        {
          label: '直播分钟数',
          value: 'minutes',
        },
        {
          label: '直播流量',
          value: 'liveFlow',
        },
        {
          label: '直播并发',
          value: 'totalConcurrent',
        },
        {
          label: '频道数',
          value: 'channels'
        },
        {
          label: '连麦分钟数',
          value: 'linkMicDuration',
        },
        {
          label: '云导播台分钟数',
          value: 'guideDuration',
        },
        {
          label: '点播流量',
          value: 'vodFlow'
        },
        {
          label: '点播空间',
          value: 'vodSpace'
        },
        {
          label: '素材库流量',
          value: 'materialtraffic',
        },
        {
          label: '素材库空间',
          value: 'materialspace'
        },
        {
          label: '视频创作（含数字人）分钟数',
          value: 'aiPptVideoWithDigitalHuman',
        },
        {
          label: '视频创作（不含数字人）分钟数',
          value: 'aiPptVideo'
        }
      ],
      conditionFilter: {
        dateRange: [], // 账单日期
        email: '',
        alterationType: '', // 变动类型
        resourceCodes: '', // 变动资源
        remark: '', // 备注
      },
      dataSource: {
        contents: [],
        pageNumber: 1,
        pageSize: 10,
        totalItems: 100
      },
      colSpan: {
        sm: 8,
        md: 8,
        lg: 8,
        xl: 8,
        xxl: 8,
      },
    };
  },

  mounted() {
    this.getAllocatableResourcesLog();
  },

  methods: {
    async getAllocatableResourcesLog() {
      const params = this.getSearchParams();
      try {
        this.loading = true;
        const res = await this.$store.dispatch('account/getGroupResourceRecord', params);
        this.dataSource.contents = res.contents;
        this.dataSource.pageNumber = res.pageNumber;
        this.dataSource.pageSize = res.pageSize;
        this.dataSource.totalItems = res.totalItems;
      } finally {
        this.loading = false;
      }
    },
    getSearchParams() {
      const { dateRange, alterationType, email, resourceCodes } = this.conditionFilter;
      const { pageNumber, pageSize } = this.dataSource;
      const params = {
        pageNumber,
        pageSize,
      };
      if (email) {
        params.email = email.trim();
      }
      if (alterationType) {
        params.alterationType = Number(alterationType);
      }
      if (resourceCodes) {
        params.resourceCodes = resourceCodes;
      }
      if (dateRange?.length) {
        const [startDate, endDate] = dateRange;

        params.startDate = startDate;
        params.endDate = dayjs(endDate).endOf('month').valueOf();
      }
      return params;
    },
    handlePageChange() {
      this.getAllocatableResourcesLog();
    },
    handleSearch() {
      this.dataSource.pageNumber = 1;
      this.dataSource.pageSize = 10;
      this.getAllocatableResourcesLog();
    },
    handleReset() {
      this.conditionFilter = {
        dateRange: [],
        email: '',
        alterationType: '',
        resourceCode: '',
        remark: '',
      };
      this.dataSource.pageNumber = 1;
      this.dataSource.pageSize = 10;
      this.handleSearch();
    },
    async handleExport() {
      const params = this.getSearchParams();
      this.asyncDownload(this.allocatableResourcesRecordExportTaskName, () => {
        return this.$store.dispatch('account/exportGroupResourceRecord', params);
      });
    },
  }
};
</script>

<style lang="scss">
.p-allocatable-resources {
  padding: 0 18px;
}
.p-allocatable-resource__operate {
  cursor: pointer;
  color: #2196f3;
  margin-right: 10px;
}

.p-allocatable-resources__filter {
  padding: 0 18px;
  .plv-condition-filter-item .plv-condition-filter-item__label {
    width: 70px;
    text-align: right;
  }
  .p-allocatable-resources__btn-group {
    display: flex;
    padding-left: 14px;
  }
}
.p-allocatable-resources__export-btn {
  margin-left: 18px;
  margin-bottom: 16px;
}
</style>
